import Alpine from "alpinejs";

import "./dropdown.css";

Alpine.data("dropdown", (initialOpen?: boolean) => {
  return {
    // State
    isOpen: initialOpen ?? false,

    // State Modifiers
    handleOpen() {
      this.isOpen = true;
    },
    handleClose() {
      this.isOpen = false;
    },
    handleToggle() {
      if (this.isOpen) this.handleClose();
      else this.handleOpen();
    },

    // Lifecycle Hooks
    init() {
      Alpine.bind(this.$root, this.root);
    },

    // Bound Directives
    root: {
      [":data-ui"]() {
        return !this.isOpen && "hidden";
      },
    },
    toggle: {
      ["@click"]() {
        this.handleToggle();
      },
    },
    open: {
      ["@click"]() {
        this.handleOpen();
      },
    },
    container: {
      ["x-cloak"]: true,
    },
    content: {
      ["x-show"]() {
        return this.isOpen;
      },
      ["@click.outside"]() {
        this.handleClose();
      },
    },
  };
});
